import familyTreeIcon from "../assets/images/icons/Rectangle 20.svg";
import familyTreeNode from "../assets/images/icons/Rectangle 21.svg";
import lineHorizontal from "../assets/images/icons/Line 21.svg";
import lineCenter from "../assets/images/icons/Line 22.svg";
import lineRight from "../assets/images/icons/Line 23.svg";
import lineTop from "../assets/images/icons/Line 24.svg";
import EstateActivityLayout from "../components/EstateActivityLayout";
import { useTranslation } from "../components/Localization";

export default function EstateFamilyTreeTaskPage() {
  const { t } = useTranslation();
  return <EstateActivityLayout taskKey="familyTree" step={2} progressIcon="top-right" backTo="/petkiek/katona" nextTo="/petkiek/eredmeny">
    <button className="task-icon-button estate-family-tree" aria-label={t("accessibility.familyTree")}>
      <span className="family-tree-diagram" aria-hidden="true">
        <img className="family-node family-node-left" src={familyTreeIcon} alt="" />
        <img className="family-node family-node-center-top" src={familyTreeNode} alt="" />
        <img className="family-node family-node-right-top" src={familyTreeNode} alt="" />
        <img className="family-node family-node-center-bottom" src={familyTreeNode} alt="" />
        <img className="family-node family-node-right-bottom" src={familyTreeNode} alt="" />
        <img className="family-line family-line-horizontal" src={lineHorizontal} alt="" />
        <img className="family-line family-line-center" src={lineCenter} alt="" />
        <img className="family-line family-line-right" src={lineRight} alt="" />
        <img className="family-line family-line-top" src={lineTop} alt="" />
      </span>
      <span className="family-tree-dots" aria-hidden="true"><i /><i /></span>
    </button>
  </EstateActivityLayout>;
}
